import React from "react";
import { motion } from "framer-motion";

function About() {
  const clients = [
    {
      name: "Edgewater Markets",
      url: "https://www.edgewatermarkets.com/",
      description:
        "A global financial technology firm providing institutional access to FX and precious metals liquidity. Quixent supports Edgewater Markets with staffing, HR, and finance operations, ensuring seamless back-office processes and efficient team management.",
    },
    {
      name: "ConfirmSlot",
      url: "https://confirmslot.com/",
      description:
        "ConfirmSlot is our in-house product — a smart booking and scheduling platform designed to simplify event and service slot management. It offers an intuitive user interface, secure payment integration, and real-time updates for both users and businesses.",
    },
    {
      name: "Rajarani Michigan",
      url: "https://rajaranimichigan.com/",
      description:
        "An authentic Indian restaurant based in Michigan, USA. Quixent developed a custom software solution to manage restaurant operations, online orders, and customer engagement — improving efficiency and digital visibility.",
    },
    {
      name: "Samy Travels",
      url: "https://samytravels.com/",
      description:
        "A trusted travel agency offering domestic packages in south india. Quixent developed a simple, user-friendly website to streamline booking and showcase travel services to a wider audience.",
    },
    {
      name: "DX Catalysts",
      url: "https://dxcatalysts.com/",
      description:
        "A digital consultancy focused on accelerating digital transformation. Quixent implemented a content management system (CMS) using WordPress, providing full functionality for content updates, scalability, and brand consistency.",
    },
  ];

  return (
    <section className="about">
      <div className="about-content">
        <motion.div
          className="about-text"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>About Us</h2>

          <section className="max-w-5xl mx-auto px-6 py-10 font-sans">
            {/* Company Overview */}
            <header className="mb-6">
              <p className="text-gray-700 leading-relaxed">
                Quixent is your trusted partner in digital transformation. We
                design and deliver dynamic websites, mobile apps, and cloud
                solutions. Our expert team provides web development, SEO, cloud
                migration, and business consulting—tailored, affordable
                solutions that strengthen your online presence and drive growth.
              </p>
            </header>

            <hr className="border-gray-200 my-8" />

            {/* Clients Section */}
            <section>
              <h2 className="text-xl font-semibold mb-4">Our Clients</h2>

              <div className="grid grid-cols-1 gap-6">
                {clients.map((client) => (
                  <article
                    key={client.name}
                    className="p-5 border border-gray-200 rounded-xl shadow-sm bg-white hover:shadow-md transition-shadow"
                  >
                    <h3 className="text-lg font-medium mb-2">
                      <a
                        href={client.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        {client.name}
                      </a>
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {client.description}
                    </p>
                  </article>
                ))}
              </div>
            </section>
          </section>
        </motion.div>
      </div>
    </section>
  );
}

export default About;
